"use strict";
function createColors(from, to, shades, alpha) {
    var rgba = [];
    var start = from.slice();
    var diff = [
        to[0] - from[0],
        to[1] - from[1],
        to[2] - from[2]
    ];
    if (alpha) {
        start.push(alpha[0]);
        diff.push(alpha[1] - alpha[0]);
    }
    for (var i = 0; i < shades; i++) {
        var inc = 1 /
            Math.max(shades - 1, 1);
        var color = [
            Math.round(start[0] + i * diff[0] * inc),
            Math.round(start[1] + i * diff[1] * inc),
            Math.round(start[2] + i * diff[2] * inc),
            alpha ? start[3] + i * diff[3] * inc : 1
        ];
        rgba.push(color);
    }
    return rgba;
}
exports.createColors = createColors;
//# sourceMappingURL=createColors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rainbow-color/~/color-map/dist/commonjs/createColors.js
// module id = 439
// module chunks = 0